import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CalendarEvent } from '../../services/agenda.service';

@Component({
  selector: 'app-google-agenda',
  templateUrl: './google-agenda.component.html',
  styleUrls: ['./google-agenda.component.scss']
})
export class GoogleAgendaComponent {

  constructor(
    public dialogRef: MatDialogRef<GoogleAgendaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { events: CalendarEvent[]; date: string, newDate: string}
  ) {}

  onCreateNewEvent(create, replace) {
    this.dialogRef.close({ createNew: create, replace: replace, event: this.data.events[0]});
  }

  close() {
    this.dialogRef.close();

  }
}